// extracted by mini-css-extract-plugin
export var borderRadius = "_fz-4";
export var large = "_fz-3";
export var logoContainer = "_fz-0";
export var nameLogo = "_fz-2";
export var small = "_fz-1";